import * as React from 'react';
import { ILxsAnchorData } from './lxs-anchor.data';
import { ILxsAnchorProps } from './lxs-anchor.props.autogenerated';

export interface ILxsAnchorViewProps extends ILxsAnchorProps<ILxsAnchorData> {}

/**
 *
 * LxsAnchor component
 * @extends {React.PureComponent<ILxsAnchorProps<ILxsAnchorData>>}
 */
class LxsAnchor extends React.PureComponent<ILxsAnchorProps<ILxsAnchorData>> {
    public render(): JSX.Element | null {
        const anchorId = this.props.config.anchorId;
        const regex = /^[A-Za-z]+[\w\-\:\.]*$/;

        if (regex.test(anchorId)) {
            return this.props.renderView(this.props);
        }
        return null;
    }
}

export default LxsAnchor;
